export default __webpack_public_path__ + "static/create-playlist-dark-mode-06f56ea75a3b09ff05de762195a40b9a.mp4";